/**
 * @file 版本选择器
 * @author Wanzhongyun
 */
import { useCallback, useMemo, useState } from 'react';
import { SelectProps } from 'antd/es/select';
import { useRouteMatch, useHistory } from 'react-router-dom';
import { useLatest } from 'react-use';

type OptionsType = Exclude<SelectProps<any>['options'], undefined>;

const useVersionSelect = (docStr: string) => {
    const routerMatch = useRouteMatch(`/${docStr}/:version`);
    const routerMatchRef = useLatest(routerMatch);
    const history = useHistory();
    const historyRef = useLatest(history);

    const [value, setValue] = useState<string>('');

    const [options, setOptions] = useState<OptionsType>([]);
    const optionValueSet = useMemo(() => {
        return new Set(options.map(v => v.value));
    }, [options]);
    const optionValueSetRef = useLatest(optionValueSet);

    const onChange = useCallback(
        (keys: string | string[]) => {
            const theKey = Array.isArray(keys) ? keys[keys.length - 1] : keys;
            console.log('theKey:', theKey);
            setValue(theKey);
            const tmp = (routerMatchRef.current?.params as any)?.version ?? '';
            const currentVersion = optionValueSetRef.current.has(tmp) ? tmp : '';
            const currentVersionPathStr = routerMatchRef.current?.url ?? '';
            const newVersion = theKey ? `/${docStr}/${theKey}` : '';
            const newURL = new URL(window.location.href);
            if (optionValueSetRef.current.has(currentVersion)) {
                newURL.pathname = newVersion + newURL.pathname.slice(currentVersionPathStr.length);
            } else {
                if (window.location.pathname.includes('inference')) {
                    newURL.pathname = newVersion + newURL.pathname.slice('/inference'.length);
                } else {
                    newURL.pathname = newVersion + newURL.pathname;
                }
            }
            if (newURL.href.includes('inference/master')) {
                // window.location.href = '/inference/master/guides/introduction/index_intro.html';
                window.open('/inference/master/guides/introduction/index_intro.html', '_self');
                // historyRef.current.push('/inference/master/guides/introduction/index_intro.html');
            } else if (newURL.href.includes('v2.4')) {
                window.open('/inference/v2.4/guides/introduction/index_intro.html', '_self');
            } else if (newURL.href.includes('v2.5')) {
                window.open('/inference/v2.5/guides/introduction/index_intro.html', '_self');
            } else if (newURL.href.includes('v2.6')) {
                window.open('/inference/v2.6/guides/introduction/index_intro.html', '_self');
            } else if (newURL.href.includes('v3.0')) {
                window.open('/inference/v3.0/guides/introduction/index_intro.html', '_self');
            } else {
                historyRef.current.push(newURL.href.slice(newURL.origin.length));
            }

            // else if (newURL.href.includes('inference/v2.4')) {
            //     window.open('/inference/v2.4/guides/introduction/index_intro.html', '_self');
            // }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [setValue, routerMatchRef, optionValueSetRef, historyRef]
    );

    const getCurrentVersion = useCallback(
        (options: OptionsType) => {
            const optionsSet = new Set(options.map(i => i.value));
            const tmp = (routerMatchRef.current?.params as any)?.version ?? '';
            return optionsSet.has(tmp) ? tmp : '';
        },
        [routerMatchRef]
    );

    return {
        value,
        setValue,

        options,
        setOptions,

        onChange,
        getCurrentVersion
    };
};

export default useVersionSelect;
